import React from 'react'

export const EventSkeloeton = () => {
  return (
    <div className='flex flex-col gap-4'>
          <div
        className='flex gap-2 h-full items-center py-4 border-b-[1px] cursor-pointer animate-pulse'
      >
        {/* Left Indicator */}
        <div className='w-[12px] h-[100px] bg-[#E0E0E0]' />

        {/* Date Section Placeholder */}
        <div className='h-full flex flex-col gap-2'>
          <div className='w-[70px] h-[24px] bg-gray-300 rounded-md' />
          <div className='w-[100px] h-[20px] bg-gray-300 rounded-md' />
        </div>

        {/* Image Placeholder */}
        <div className='w-[100px] h-[100px] bg-gray-300 rounded-[4px]' />

        {/* Event Info Section */}
        <div className='flex gap-2 flex-col flex-1'>
          <div className='w-[250px] h-[18px] bg-gray-300 rounded-md' />
          <div className='w-[200px] h-[12px] bg-gray-300 rounded-md' />
          <div className='flex items-center gap-1'>
            <img src="" alt='time-icon' className='w-4 h-4' />
            <div className='w-[100px] h-[12px] bg-gray-300 rounded-md' />
          </div>
        </div>
      </div>
          <div
        className='flex gap-2 h-full items-center py-4 border-b-[1px] cursor-pointer animate-pulse'
      >
        {/* Left Indicator */}
        <div className='w-[12px] h-[100px] bg-[#E0E0E0]' />

        {/* Date Section Placeholder */}
        <div className='h-full flex flex-col gap-2'>
          <div className='w-[70px] h-[24px] bg-gray-300 rounded-md' />
          <div className='w-[100px] h-[20px] bg-gray-300 rounded-md' />
        </div>

        {/* Image Placeholder */}
        <div className='w-[100px] h-[100px] bg-gray-300 rounded-[4px]' />

        {/* Event Info Section */}
        <div className='flex gap-2 flex-col flex-1'>
          <div className='w-[250px] h-[18px] bg-gray-300 rounded-md' />
          <div className='w-[200px] h-[12px] bg-gray-300 rounded-md' />
          <div className='flex items-center gap-1'>
            <img src="" alt='time-icon' className='w-4 h-4' />
            <div className='w-[100px] h-[12px] bg-gray-300 rounded-md' />
          </div>
        </div>
      </div>
          <div
        className='flex gap-2 h-full items-center py-4 border-b-[1px] cursor-pointer animate-pulse'
      >
        {/* Left Indicator */}
        <div className='w-[12px] h-[100px] bg-[#E0E0E0]' />

        {/* Date Section Placeholder */}
        <div className='h-full flex flex-col gap-2'>
          <div className='w-[70px] h-[24px] bg-gray-300 rounded-md' />
          <div className='w-[100px] h-[20px] bg-gray-300 rounded-md' />
        </div>

        {/* Image Placeholder */}
        <div className='w-[100px] h-[100px] bg-gray-300 rounded-[4px]' />

        {/* Event Info Section */}
        <div className='flex gap-2 flex-col flex-1'>
          <div className='w-[250px] h-[18px] bg-gray-300 rounded-md' />
          <div className='w-[200px] h-[12px] bg-gray-300 rounded-md' />
          <div className='flex items-center gap-1'>
            <img src="" alt='time-icon' className='w-4 h-4' />
            <div className='w-[100px] h-[12px] bg-gray-300 rounded-md' />
          </div>
        </div>
      </div>
          <div
        className='flex gap-2 h-full items-center py-4 border-b-[1px] cursor-pointer animate-pulse'
      >
        {/* Left Indicator */}
        <div className='w-[12px] h-[100px] bg-[#E0E0E0]' />

        {/* Date Section Placeholder */}
        <div className='h-full flex flex-col gap-2'>
          <div className='w-[70px] h-[24px] bg-gray-300 rounded-md' />
          <div className='w-[100px] h-[20px] bg-gray-300 rounded-md' />
        </div>

        {/* Image Placeholder */}
        <div className='w-[100px] h-[100px] bg-gray-300 rounded-[4px]' />

        {/* Event Info Section */}
        <div className='flex gap-2 flex-col flex-1'>
          <div className='w-[250px] h-[18px] bg-gray-300 rounded-md' />
          <div className='w-[200px] h-[12px] bg-gray-300 rounded-md' />
          <div className='flex items-center gap-1'>
            <img src="" alt='time-icon' className='w-4 h-4' />
            <div className='w-[100px] h-[12px] bg-gray-300 rounded-md' />
          </div>
        </div>
      </div>
          <div
        className='flex gap-2 h-full items-center py-4 border-b-[1px] cursor-pointer animate-pulse'
      >
        {/* Left Indicator */}
        <div className='w-[12px] h-[100px] bg-[#E0E0E0]' />

        {/* Date Section Placeholder */}
        <div className='h-full flex flex-col gap-2'>
          <div className='w-[70px] h-[24px] bg-gray-300 rounded-md' />
          <div className='w-[100px] h-[20px] bg-gray-300 rounded-md' />
        </div>

        {/* Image Placeholder */}
        <div className='w-[100px] h-[100px] bg-gray-300 rounded-[4px]' />

        {/* Event Info Section */}
        <div className='flex gap-2 flex-col flex-1'>
          <div className='w-[250px] h-[18px] bg-gray-300 rounded-md' />
          <div className='w-[200px] h-[12px] bg-gray-300 rounded-md' />
          <div className='flex items-center gap-1'>
            <img src="" alt='time-icon' className='w-4 h-4' />
            <div className='w-[100px] h-[12px] bg-gray-300 rounded-md' />
          </div>
        </div>
      </div>
          <div
        className='flex gap-2 h-full items-center py-4 border-b-[1px] cursor-pointer animate-pulse'
      >
        {/* Left Indicator */}
        <div className='w-[12px] h-[100px] bg-[#E0E0E0]' />

        {/* Date Section Placeholder */}
        <div className='h-full flex flex-col gap-2'>
          <div className='w-[70px] h-[24px] bg-gray-300 rounded-md' />
          <div className='w-[100px] h-[20px] bg-gray-300 rounded-md' />
        </div>

        {/* Image Placeholder */}
        <div className='w-[100px] h-[100px] bg-gray-300 rounded-[4px]' />

        {/* Event Info Section */}
        <div className='flex gap-2 flex-col flex-1'>
          <div className='w-[250px] h-[18px] bg-gray-300 rounded-md' />
          <div className='w-[200px] h-[12px] bg-gray-300 rounded-md' />
          <div className='flex items-center gap-1'>
            <img src="" alt='time-icon' className='w-4 h-4' />
            <div className='w-[100px] h-[12px] bg-gray-300 rounded-md' />
          </div>
        </div>
      </div>
     
    </div>
  )
}
